import React, {useEffect, useState} from 'react'
import './Onboard.css'
import onboardSuccess from "./../assets/onboardSuccess.png"
import onboardFail from "./../assets/onboardFailed.png"
import {auth} from '../firebase'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import axios from 'axios'


const Onboard = ({changeOnboard}) => {
    const [errorFB,setErrorFB]= useState(false)  //firebase user
    const [orgCreated,setOrgCreated]= useState(false) 
    const [userCreated,setUserCreated]= useState(false) 

    const [data, setData] = useState({
        orgName: '',      
        domainName:'',
        name: '',    
        phone:'',
        email:'',
        password:''
    });
    const { orgName, domainName, name, phone, email, password } = data;

    const [contactData, setContactData] = useState({
        "email": "",
        "phone": ""
    })

    const [orgData, setOrgData] = useState({
        "address": {},
        "contact": contactData,
        "imageUrl": "",
        "orgName": "",
        "parentOrgId": ""
    })

    const [userDetails, setUserDetails] = useState({
        "firstname": "",
        "lastname": "",
        "gender": "",
        "dateOfBirth": "",
        "address": {},
        "contact": {},
        "geoCodeInfo": {},
        "imageUrl": ""
    })

    const [userData, setUsetData] = useState({
        "orgId": "",
        "userType": "",
        "classId": "",
        "admissionId": "",
        "transportRouteId": "",
        "userDetails": userDetails,
        "paymentsRecord": {},
    })

    const [orgInfo, setOrgInfo] = useState(null)
    const [orgId, setOrgId] = useState('')

    const [isChecked, setIsChecked] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
    }

    const changeHandler = e => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    useEffect(()=>{
        setContactData({
            "email": email,
            "phone": phone
        })
    },[email,phone])

    useEffect(()=>{
        setOrgData({
            "address": {},
            "contact": contactData,
            "imageUrl": "",
            "orgName": orgName,
            "parentOrgId": ""
        })
    },[contactData,orgName])

    //userDetail
    useEffect(()=>{
        setUserDetails({
            "firstname": name,
            "lastname": "",
            "gender": "",
            "dateOfBirth": "",
            "address": {},
            "contact": contactData,
            "geoCodeInfo": {},
            "imageUrl": ""
        })
    },[contactData,name])

    //userData
    useEffect(()=>{
        setUsetData({
            "orgId": orgId,
            "userType": "admin",
            "classId": "",
            "admissionId": "",
            "transportRouteId": "",
            "userDetails": userDetails,
            "paymentsRecord": {},
        })
    },[userDetails, orgId])


    const submitHandler = e => {
        e.preventDefault()
        if(isChecked) {
            //for showing accept terms and conditions
            setIsSubmit(true) 
            // create user in firebase
            createUserWithEmailAndPassword(auth, email,password)
            .then(
                user => setErrorFB(false)
            ).catch(
                err => setErrorFB(true)
            )
            //create org
            axios.post('http://localhost:3000/organizations/api/org',orgData)
            .then(function(response){
                setOrgCreated(true)
                setOrgId(response.data.orgId)
                console.log(response.data.orgId)
            }).catch(function(error){
                setOrgCreated(false)
            })
        }
    }
    useEffect(()=>{
        //create user
        if(userData.orgId && isSubmit && !userCreated){
            axios.post('http://localhost:3000/organizations/api/users',userData)
            .then(function(response){
                console.log(response)
                setUserCreated(true)
            }).catch(function(error){
                setUserCreated(false)
            }) 
        }
    },[userData])

  return (
    <div className="wrapOnboard">
        {!isSubmit && <div className="onboardForm">
            <div className="title-onboard">Create your EgurukulSchool</div>
            <form onSubmit={submitHandler}>
                <div className="itemFormOB">
                    <label>Organization Name*</label>
                    <input type="text" placeholder='' name="orgName" value={orgName} onChange={changeHandler} />
                </div>
                {/* <div className="itemFormOB">
                    <label>Domain Name*</label>
                    <input type="text" placeholder='' name="domainName" value={domainName} onChange={changeHandler} />
                </div> */}
                <div className="itemFormOB">
                    <label>Your Name*</label>
                    <input type="text" placeholder='' name="name" value={name} onChange={changeHandler} />
                </div>
                <div className="itemFormOB">
                    <label>Mobile Number*</label>
                    <input type="text" placeholder='' name="phone" value={phone} onChange={changeHandler} />
                </div>
                <div className="itemFormOB">
                    <label>Email Id*</label>
                    <input type="text" placeholder='' name="email" value={email} onChange={changeHandler} />
                </div>
                <div className="itemFormOB">
                    <label>Password*</label>
                    <input type="password" placeholder='' name="password" value={password} onChange={changeHandler} />
                </div>
                <div className="tndc">
                    <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange}/>
                    <span>I read and accept terms and conditions.</span>
                </div>
                { isSubmit && !isChecked && <div className="alertTnC">
                    <span>Please accept the terms and conditions</span>
                </div>}
                <div>
                    <button className="btnOBsumit">Create account</button>
                </div>
            </form>
            <div class="circleA"></div>
            <div class="circleB"></div>
        </div>}

        {isSubmit && !errorFB && orgCreated && userCreated && <div className="onboardBox">
            <div>
                <img src={onboardSuccess} style={{height:"600px"}}/>
            </div>
            <div className="onboardSuccess">
                <div>
                    <span>Your account has been created successfully</span>
                </div>
                <div>
                    <button onClick={()=>changeOnboard(false)}>Go to Home</button>
                </div>
            </div>
        </div>}

        {isSubmit && ( errorFB || !orgCreated || !userCreated )  && <div className="onboardBox">
            <div>
                <img src={onboardFail} style={{height:"600px"}}/>
            </div>
            <div className="onboardFail">
                <div>
                    <span>Something went wrong, please try again</span>
                </div>
                <div>
                    <button onClick={()=>{setIsSubmit(false)}}>Try again</button>
                </div>
            </div>
        </div>}

    </div>
  )
}

export default Onboard